export class RedeemCode {
    code: string

    constructor(
        code: string
    ) {
        this.code = code
    }
}